import React from 'react';
import './themeFloaters.css';

export const ThemeFloaters = ({ page }) => <div className={`theme-floaters theme-floaters-${page}`} aria-hidden="true" data-testid={`${page}-floaters`}>
  <span className="float-orb theme-floater theme-floater-left" data-testid={`${page}-floater-left`} />
  <span className="float-orb theme-floater theme-floater-right" data-testid={`${page}-floater-right`} />
  <span className="float-orb theme-floater theme-floater-lower" data-testid={`${page}-floater-lower`} />
</div>;